import React, { useEffect } from 'react';
import { LandingPage } from './pages/LandingPage';
import { initMetaPixel, trackEvent } from './hooks/useMetaPixel';
export function App() {
  useEffect(() => {
    initMetaPixel();
    trackEvent('PageView');
  }, []);
  return <LandingPage data-id="element-0" />;
}